export default __webpack_public_path__ + "static/media/TableDelete.92f06970.svg";